import { isBlockAboveEmpty, ELEMENT_TODO_LI } from '@udecode/plate';

import { toggleTodoList } from '../../components/button/TodoListButton';
import { getTodoListItemEntry } from './getTodoListItemEntry';
import { insertTodoListItem } from './insertTodoListItem';

export const insertBreakTodoList = (
  editor,
  options,
) => {
  if (!editor.selection) return;

  const res = getTodoListItemEntry(editor);

  // If selection is in a todo li
  if (res) {
    if (isBlockAboveEmpty(editor)) {
      toggleTodoList(editor, { activeType: ELEMENT_TODO_LI });
      return true;
    }

    const inserted = insertTodoListItem(editor, options);
    if (inserted) return true;
  }
};